import React from "react";
import SessionManager from "./SessionManager";
import ModalWindow from "../Shared/ModalWindow";
import BootstrapTable from "@partseye/react-bootstrap-table-next";


export default class CrossBalanceModal extends React.Component {

    constructor (props) {

        super(props);
        this.state = {
            "dataError": false,
            "crossBalanceOrderLines": this.props.orderState === null ? [] : this.props.orderState.CrossBalance.CrossBalanceOrderLines.map((item) => ({...item})),
            "crossBalanceReference": this.props.orderState === null ? "" : this.props.orderState.CrossBalance.reference,
            "crossBalanceRefValid": true,
            "crossBalanceEmptyRef": this.props.orderState === null ? null : this.props.orderState.CrossBalance.reference === "" || this.props.orderState.CrossBalance.reference === null
        };

    }

    updateCrossBalanceReference (event) {

        let reference = event.target.value;
        reference = reference.replace(
            /[^a-z0-9 -]/ig,
            ""
        );
        const validReference = reference.toUpperCase() !== this.props.orderRefTextBox.toUpperCase();
        reference === "" ? this.setState({"crossBalanceEmptyRef": true}) : this.setState({"crossBalanceEmptyRef": false});
        this.setState({
            "crossBalanceReference": reference,
            "crossBalanceRefValid": validReference
        });

    }

    onSelectAll (isSelected, rows, e) {

        this.setState({
            "crossBalanceOrderLines": this.state.crossBalanceOrderLines.map((item, index) => ({
                ...item,
                "IsSelectedClientSide": isSelected
            }))
        });

    }


    onRowSelect (row, isSelected) {

        const selectedIndex = this.state.crossBalanceOrderLines.indexOf(row);
        this.setState({
            "crossBalanceOrderLines": this.state.crossBalanceOrderLines.map((item, index) => {

                if (index !== selectedIndex) {

                    return item;

                }

                return {
                    ...item,
                    "IsSelectedClientSide": isSelected
                };

            })
        });

    }


    render () {

        let modalBody,
            modalTitle = "Cross Balance",

            data = [];
        if (this.props.orderState !== null) {

            data.push(...this.state.crossBalanceOrderLines);

        }

        const tableColumns = [
                {"dataField": "PartNumber",
                    "text": "Part Number",
                    "sort": true},
                {"dataField": "Description",
                    "text": "Description",
                    "sort": true},
                {"dataField": "AvailableQuantity",
                    "text": "Available Quantity",
                    "sort": true},
                {"dataField": "SuggestedQuantity",
                    "text": "Suggested Qty",
                    "sort": true}
            ],


            defaultSorted = [
                {
                    "dataField": "PartNumber",
                    "order": "asc"
                }
            ],

            redText = {
                "color": "red",
                "textAlign": "left",
                "display": "flex",
                "paddingLeft": "5px"

            },
            redReferenceBox = {
                "borderColor": "red",
                "display": "inline - block",
                "float": "left"
            },

            validReferenceBox = {
                "display": "inline - block",
                "float": "left"
            },

            selectRow = {
                "mode": "checkbox",
                "clickToSelect": true,
                "onSelect": this.onRowSelect.bind(this),
                "selected": this.props.orderState === null ? [] : this.state.crossBalanceOrderLines.filter((item) => item.IsSelectedClientSide).map((item) => item.PartNumber),
                "onSelectAll": this.onSelectAll.bind(this)
            };

        if (this.props.orderState !== null && data.length > 0) {

            modalBody =
                <>
                 <div className="refernceDivCb">
                    <label className="crossBalanceReferenceLabel">Reference</label>
                    <input style={!this.state.crossBalanceEmptyRef ? validReferenceBox : redReferenceBox} type="text" maxLength="7" value={(this.props.orderState === null || this.props.orderState.CrossBalance.reference === null) && this.state.crossBalanceReference === null ? '': this.state.crossBalanceReference} onChange={(event) => this.updateCrossBalanceReference(event)} />
                </div>
                <div>
                    <label style={redText} hidden={this.state.crossBalanceRefValid}>{this.props.pageText.stockOrderCrossBalanceReference}</label>
                    <label style={redText} hidden={!this.state.crossBalanceEmptyRef}>{this.props.pageText.stockOrderEmptyCrossBalanceReference}</label>
                </div>
                    <BootstrapTable
                        bootstrap4
                        keyField='PartNumber'
                        columns={tableColumns}
                        data={data}
                        defaultSorted={defaultSorted}
                        headerClasses="thead-light"
                        selectRow={selectRow}
                        striped
                        condensed
                    />
                <div className="bottomButtons">
                    <button className="btn btn-secondary crossBalanceModalButton " type="button" data-dismiss="modal" onClick={this.props.onClickCancel}>{this.props.pageText.cancel}</button>
                    <button className="btn btn-secondary crossBalanceModalButton" disabled={!this.state.crossBalanceRefValid || this.state.crossBalanceEmptyRef} type="button" onClick={this.props.onClickYes}>{this.props.pageText.stockOrderSave}</button>
                    </div>
                </>
            ;

        }
        return (
            <ModalWindow
                modalBody={modalBody}
                modalId="crossBalanceModal"
                modalSize="modal-lg"
                modalTitle={modalTitle}
            />
        );

    }

}
